import { Container, Card, CardHeader } from "reactstrap";
import BreadCrumb from "components/common/BreadCrumb";
import { useSearchParams } from "react-router-dom";
import { VisitLogTable } from "./VisitLogTable";

import { getDocumentTitle } from "utils/helpers";

const VisitLogList = () => {
  document.title = getDocumentTitle("Visit Logs");
  const [searchParams] = useSearchParams();
  const rawAmc = searchParams.get("amcId");
  const amcIdNum = rawAmc != null ? Number(rawAmc) : NaN;
  const amcId =
    Number.isInteger(amcIdNum) && amcIdNum > 0 ? amcIdNum : undefined;

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Visit Logs" pageTitle="AMC Management" />
        <Card>
          <CardHeader className="d-flex justify-content-between">
            <h5 className="card-title mb-0">Visit Log List</h5>
          </CardHeader>
          <div className="card-body pt-0">
            <VisitLogTable amcId={amcId} />
          </div>
        </Card>
      </Container>
    </div>
  );
};

export default VisitLogList;
